// Import 3rd party libraries
import {gsap} from "gsap";
import {CustomEase} from "gsap/CustomEase";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(CustomEase);

export default function() {
    const matches = {
        isMobile: "(max-width: 480px)",
        isTablet: "(min-width: 481px) and (max-width: 768px)",
        isLaptop: "(min-width: 769px) and (max-width: 1024px)",
        isDesktop: "(min-width: 1025px) and (max-width: 1200px)",
        isTV: "(min-width: 1201px)",
        reduceMotion: "(prefers-reduced-motion: reduce)"
    }
    
    let mm = gsap.matchMedia();
    
    mm.add(matches, (context) => {

        gsap.timeline({
            scrollTrigger: {
                trigger: "#testimonial",
                start: "clamp(top 70%)",
                end: "clamp(bottom bottom)"
            }
        })

        .from("#testimonial-content .testimonial-container", {
            stagger: .3,
            duration: 1,
            y: 100,
            ease: CustomEase.create("custom", "M0,0 C0.126,0.382 0.328,1.03 0.416,1.054 0.482,1.072 0.516,0.988 0.548,0.988 0.577,0.988 0.618,1.017 0.652,1.018 0.688,1.018 0.69,1 0.732,1 0.764,1 0.758,1.012 0.794,1.012 0.84,1.012 0.855,1 0.9,1 0.948,1 0.982,1 1,1")
        })

        .fromTo("#testimonial-content .testimonial",
            {
                "--seperator-width": "0%",
                opacity: 0        
            },
            {                
                stagger: .1,
                duration: .5,
                opacity: 1,
                "--seperator-width": "20%"
            },
        "-=100%")

        .from("#testimonial-content .testimonial-container img", {
            stagger: .1,
            duration: 1,
            y: -50,
            opacity: 0,
            ease: CustomEase.create("custom", "M0,0 C0.126,0.382 0.328,1.03 0.416,1.054 0.482,1.072 0.516,0.988 0.548,0.988 0.577,0.988 0.618,1.017 0.652,1.018 0.688,1.018 0.69,1 0.732,1 0.764,1 0.758,1.012 0.794,1.012 0.84,1.012 0.855,1 0.9,1 0.948,1 0.982,1 1,1")
        }, "-=1");
    });
}